import { useQuery } from '@tanstack/react-query';
import ChessRestClient from '@/Api/ChessRestClient';
import { getLocalStorage } from '@/Utils/CommonUtils';

export interface OrderDetailsResponse {
  order_id: string;
  amount_paid: number;
  currency: string;
  program_name: string;
  plan_type: 'personal' | 'group' | 'webinar';
  duration: number;
  sessions: number;
  selected_coach?: 'general' | 'international_master' | 'grand_master' | null;
  first_class_date?: string | null;
  first_class_time?: string | null;
  coach_name?: string | null;
  has_change_request?: boolean;
  requested_days?: string | null;
  requested_time?: string | null;
  renewal_meta?: Record<string, any> | null;
}

export default function useGetOrderDetails(
  orderId: string | undefined,
  options?: { enabled?: boolean },
) {
  return useQuery<OrderDetailsResponse>(
    ['order-details', orderId],
    async () => {
      if (!orderId) {
        throw new Error('Order ID is required');
      }

      const token = await getLocalStorage('access_token');
      if (!token) {
        throw new Error('Authentication token not found');
      }

      const response = await ChessRestClient.get<OrderDetailsResponse>(
        `subscription/v1/get-order-details/?order_id=${encodeURIComponent(orderId)}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            Accept: 'application/json',
          },
        },
      );
      return response.data;
    },
    {
      enabled: options?.enabled !== false && !!orderId,
      staleTime: 5 * 60 * 1000, // 5 minutes
      cacheTime: 10 * 60 * 1000, // 10 minutes
    },
  );
}

